<script setup>
defineProps({
  width: {
    type: Number,
    default: 12,
  },
  height: {
    type: Number,
    default: 13,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconAI" clip-path="url(#clip0_1428_107585)">
      <g id="Vector">
        <path
          d="M13.8649 12.4008L9.81449 10.1856L7.59926 6.13519C7.54883 6.04285 7.47447 5.96578 7.38398 5.9121C7.29349 5.85841 7.19021 5.83008 7.085 5.83008C6.97978 5.83008 6.87651 5.85841 6.78602 5.9121C6.69553 5.96578 6.62117 6.04285 6.57074 6.13519L4.3555 10.1856L0.305114 12.4008C0.212769 12.4512 0.135707 12.5256 0.0820191 12.6161C0.0283315 12.7066 0 12.8099 0 12.9151C0 13.0203 0.0283315 13.1236 0.0820191 13.2141C0.135707 13.3045 0.212769 13.3789 0.305114 13.4293L4.3555 15.6446L6.57074 19.695C6.62117 19.7873 6.69553 19.8644 6.78602 19.9181C6.87651 19.9717 6.97978 20.0001 7.085 20.0001C7.19021 20.0001 7.29349 19.9717 7.38398 19.9181C7.47447 19.8644 7.54883 19.7873 7.59926 19.695L9.81449 15.6446L13.8649 13.4293C13.9572 13.3789 14.0343 13.3045 14.088 13.2141C14.1417 13.1236 14.17 13.0203 14.17 12.9151C14.17 12.8099 14.1417 12.7066 14.088 12.6161C14.0343 12.5256 13.9572 12.4512 13.8649 12.4008Z"
          fill="#8C8C8C"
        />
        <path
          d="M9.66527 5.83402L12.5746 7.42543L14.1661 10.3348C14.2165 10.4271 14.2908 10.5042 14.3813 10.5579C14.4718 10.6116 14.5751 10.6399 14.6803 10.6399C14.7855 10.6399 14.8888 10.6116 14.9793 10.5579C15.0698 10.5042 15.1441 10.4271 15.1946 10.3348L16.7856 7.42543L19.695 5.83402C19.7873 5.78359 19.8644 5.70923 19.9181 5.61874C19.9717 5.52825 20.0001 5.42498 20.0001 5.31976C20.0001 5.21455 19.9717 5.11127 19.9181 5.02078C19.8644 4.93029 19.7873 4.85593 19.695 4.8055L16.7856 3.21449L15.1953 0.305114C15.1449 0.212769 15.0706 0.135707 14.9801 0.0820191C14.8896 0.0283315 14.7863 0 14.6811 0C14.5759 0 14.4726 0.0283315 14.3821 0.0820191C14.2916 0.135707 14.2173 0.212769 14.1668 0.305114L12.5746 3.21449L9.66527 4.80472C9.57293 4.85515 9.49586 4.92951 9.44217 5.02C9.38849 5.11049 9.36016 5.21376 9.36016 5.31898C9.36016 5.4242 9.38849 5.52747 9.44217 5.61796C9.49586 5.70845 9.57293 5.78359 9.66527 5.83402Z"
          fill="#8C8C8C"
        />
        <path
          d="M19.695 16.5192L18.3071 15.7602L17.5481 14.3723C17.4977 14.2799 17.4233 14.2027 17.3328 14.149C17.2423 14.0952 17.1389 14.0668 17.0336 14.0668C16.9283 14.0668 16.825 14.0952 16.7345 14.149C16.6439 14.2027 16.5696 14.2799 16.5192 14.3723L15.7602 15.7602L14.3723 16.5192C14.2799 16.5696 14.2027 16.6439 14.149 16.7345C14.0952 16.825 14.0668 16.9283 14.0668 17.0336C14.0668 17.1389 14.0952 17.2423 14.149 17.3328C14.2027 17.4233 14.2799 17.4977 14.3723 17.5481L15.7602 18.3071L16.5192 19.695C16.5696 19.7874 16.6439 19.8646 16.7345 19.9183C16.825 19.9721 16.9283 20.0004 17.0336 20.0004C17.1389 20.0004 17.2423 19.9721 17.3328 19.9183C17.4233 19.8646 17.4977 19.7874 17.5481 19.695L18.3071 18.3071L19.695 17.5481C19.7874 17.4977 19.8646 17.4233 19.9183 17.3328C19.9721 17.2423 20.0004 17.1389 20.0004 17.0336C20.0004 16.9283 19.9721 16.825 19.9183 16.7345C19.8646 16.6439 19.7874 16.5696 19.695 16.5192Z"
          fill="#8C8C8C"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1428_107585">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
